import React, { useState } from 'react';
import {
    Box,
    Container,
    Typography,
    Button,
    Stack,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';

interface VehicleSuccessPageProps {
    mode: 'light' | 'dark';
    setMode: (mode: 'light' | 'dark') => void;
}

const VehicleSuccessPage = ({ mode, setMode }: VehicleSuccessPageProps) => {
    const navigate = useNavigate();
    const [isLoggedIn, setLoggedin] = useState<boolean>(false);

    return (
        <>
            <Header  />

            <Box
                sx={{
                    backgroundColor: '#f4f6f8',
                    py: { xs: 8, sm: 12 },
                    textAlign: 'center',
                    minHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
            >
                <Container maxWidth="sm">
                    <CheckCircleOutlineIcon
                        sx={{ fontSize: 80, color: 'success.main', mb: 3 }}
                    />
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Vehicle Created Successfully!
                    </Typography>
                    <Typography variant="body1" color="text.secondary" mb={4}>
                        Your vehicle has been created successfully. After all confirmations, 
                        all the information will be published.
                    </Typography>
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ bgcolor: '#ffce00', color: '#000' }}
                            onClick={() => navigate('/vehicle-listing')}
                        >
                            View Listings
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/')}
                        >
                            Back to Home
                        </Button>
                    </Stack>
                </Container>
            </Box>

            <Footer />
        </>
    );
};

export default VehicleSuccessPage;
